import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import orderService from "services/orderService";

export const fetchOrders = createAsyncThunk(
	"vino/orders/fetchList",
	async (_, { dispatch }) => {
		try {
			dispatch(showLoader());
			return await orderService.list();
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while getting orders",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
		}
	}
);

export const setOrderCancelling = (id, isSubmitting) => (dispatch) => {
	const input = {
		id,
		changes: { isCancelling: isSubmitting },
	};
	dispatch(updateOrder(input));
};

const orderAdapter = createEntityAdapter({});

export const {
	selectAll: selectOrders,
	selectById: selectOrdersById,
} = orderAdapter.getSelectors((state) => state.vino.orders);

const ordersSlice = createSlice({
	name: "vino/orders",
	initialState: orderAdapter.getInitialState(),
	reducers: {
		updateOrder: orderAdapter.updateOne,
	},
	extraReducers: {
		[fetchOrders.fulfilled]: orderAdapter.setAll,
	},
});

export const { updateOrder } = ordersSlice.actions;

export default ordersSlice.reducer;
